import React, { useState } from "react";
import StickyISI from "../../sticky-isi";

import PatientIsi from "./isi-content";
import AnchorLink from "react-anchor-link-smooth-scroll";

export default function Isi({ footerRef }) {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <StickyISI
      footerRef={footerRef}
      stickyHeight={150}
      stickyStyles={{
        backgroundColor: "#ffffff",
        height: 150,
        width: "100%",
        boxShadow: "0px 3px 10px 5px #d8d8d8",
        paddingTop: 5,
      }}
      className="isi"
      onFooterStateChange={(result) => {
        setIsExpanded(result);
      }}
    >
      <div className="isi-content-wrapper">
        <div className="isi-content gutter-all">
          {!isExpanded && (
            <div className="content-container">
              <div className="centered-content">
                <div className="isi-anchor-container">
                  <AnchorLink
                    href="#normal-chappy-isi"
                    className="btn-expand-isi gutter-right"
                    offset={155}
                  >
                    <span className="btn-expand-text">Show More</span>
                    <span className="up-arrow-symbol">▲</span>
                  </AnchorLink>
                </div>
              </div>
            </div>
          )}

          <PatientIsi />
        </div>
      </div>
    </StickyISI>
  );
}
